// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "3f775d0f3075d58c","396": "87d2ae70d1073c5a","460": "7515259d2d7068d2","498": "3ff1b0b3cb947cb9","917": "b39d45b6c4211751","985": "b2746030e0ed0202",}[chunkId] + ".chunk.js"
}